/* Express-Zahlknöpfe (Apple Pay, Google Pay, PayPal …) erst nach Einwilligung – Inhaber 05.10.2026.
   Grund: Shopifys Express-Knöpfe laden beim Seitenaufruf das PayPal-SDK (Anfragen an www.paypal.com, Cookies), noch
   bevor der Kunde etwas tut. Deshalb steht die Ausgabe von `payment_button` (Produktseite, snippets/buy-buttons) und
   `content_for_additional_checkout_buttons` (Warenkorb, sections/main-cart-footer) in einem <template data-cm-wallets>:
   inert, nichts wird geladen. Erst wenn Shopifys Customer Privacy API die Marketing-Einwilligung meldet
   (marketingAllowed(); außerhalb von Einwilligungsregionen ist das ohne Banner wahr), wird der Inhalt eingesetzt und
   Shopify.PaymentButton.init() aufgerufen. Bis dahin ein kurzer Hinweis (data-cm-wallets-note) mit „Cookie-Einstellungen“.
   Die normale Kasse („Zur Kasse“) mit allen Zahlungsarten inkl. PayPal bleibt immer verfügbar. Kategorie hier ändern: NEED. */
(() => {
  if (window.cmConsentWallets) return;
  window.cmConsentWallets = true;
  const NEED = (cp) => typeof cp.marketingAllowed === 'function' && cp.marketingAllowed();
  const api = () => (window.Shopify && window.Shopify.customerPrivacy) || null;
  const allowed = () => { const cp = api(); try { return !!(cp && NEED(cp)); } catch (e) { return false; } };
  const notes = (show) => document.querySelectorAll('[data-cm-wallets-note]').forEach((n) => { n.hidden = !show; });
  const reveal = () => {
    const ts = document.querySelectorAll('template[data-cm-wallets]');
    if (!ts.length) return;
    ts.forEach((t) => t.replaceWith(t.content.cloneNode(true)));
    notes(false);
    try { if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') window.Shopify.PaymentButton.init(); } catch (e) { /* Knöpfe bleiben weg, Kasse geht */ }
  };
  const check = () => { if (allowed()) reveal(); else notes(true); };
  const start = () => {
    if (api()) return check();
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => { if (!err) check(); else notes(true); });
    } else notes(true);
  };
  document.addEventListener('visitorConsentCollected', () => setTimeout(check, 0));
  // Neu gezeichnete Abschnitte (Variantenwechsel, Warenkorb) bringen neue <template>: nur dann einsetzen, sonst nichts tun.
  new MutationObserver(() => { if (document.querySelector('template[data-cm-wallets]')) { if (allowed()) reveal(); else notes(true); } })
    .observe(document.body || document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
